import React from 'react';

const DisplayCurrency = (value) => {
    switch(value) {
      case 'USD':
        return "$";
      case 'GBP':
      default:
        return "£";
    }
};

export default DisplayCurrency;
